import { render, staticRenderFns } from "./GiftCardReminder.vue?vue&type=template&id=8352f9a4&scoped=true"
import script from "./GiftCardReminder.vue?vue&type=script&lang=js"
export * from "./GiftCardReminder.vue?vue&type=script&lang=js"
import style0 from "./GiftCardReminder.vue?vue&type=style&index=0&id=8352f9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8352f9a4",
  null
  
)

export default component.exports